// extracted by mini-css-extract-plugin
module.exports = {"jobs":"JobList_jobs__Vow3Z"};